var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrustpilotRating = function SvgTrustpilotRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trustpilot-rating_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00B67A",
    d: "M21 0H0v20h21zM43.75 0h-21v20h21zM66.5 0h-21v20h21zM89.25 0h-21v20h21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M112 0H91v20h21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B67A",
    d: "M101.5 0H91v20h10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.5 13.48 3.194-.772 1.334 3.917zm7.35-5.063h-5.622L10.5 3.375 8.772 8.417H3.15l4.55 3.125-1.728 5.041 4.55-3.125 2.8-1.916zM33.25 13.48l3.194-.772 1.334 3.917zm7.35-5.063h-5.622L33.25 3.375l-1.728 5.042H25.9l4.55 3.125-1.728 5.041 4.55-3.125 2.8-1.916zM56 13.48l3.194-.772 1.334 3.917zm7.35-5.063h-5.622L56 3.375l-1.728 5.042H48.65l4.55 3.125-1.728 5.041 4.55-3.125 2.8-1.916zM78.75 13.48l3.194-.772 1.334 3.917zm7.35-5.063H80.48L78.75 3.375l-1.728 5.042H71.4l4.55 3.125-1.728 5.041 4.55-3.125 2.8-1.916zM101.5 13.48l3.194-.772 1.335 3.917zm7.35-5.063h-5.621L101.5 3.375l-1.728 5.042H94.15l4.55 3.125-1.728 5.041 4.55-3.125 2.8-1.916z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "trustpilot-rating_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h112v20H0z"
  })))));
};
export default SvgTrustpilotRating;